import React from 'react'
import { ToastContainer } from 'react-toastify'
import Checkout from './components/Checkout';
import{QueryClient, QueryClientProvider} from '@tanstack/react-query'
import Cookies from 'js-cookie';

import './styles/checkout.css'

export default function App() {
    const queryClient = new QueryClient()

    const handleCheckoutComplete = (orderId : string) => {
        Cookies.remove('bfx-checkout-id');
        window.location.href = '/account/order?id=' + orderId;
    }

    return (
        <div className='h-100' style={{minHeight: '600px'}}>
            <QueryClientProvider client={queryClient}>
                <Checkout onComplete={handleCheckoutComplete} />
            </QueryClientProvider>
            <ToastContainer />
        </div>
    )
}
    